/* ===========================================================
   fadelessart -- Shared JavaScript
   =========================================================== */

// -- Header scroll effect --
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function onScroll() {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// -- Mobile nav toggle --
(function() {
  var btn = document.querySelector('.mobile-menu-btn');
  var nav = document.querySelector('.mobile-nav');
  var overlay = document.querySelector('.mobile-nav-overlay');
  var closeBtn = document.querySelector('.mobile-nav-close');
  if (!btn || !nav) return;

  function toggle() {
    btn.classList.toggle('active');
    nav.classList.toggle('open');
    if (overlay) overlay.classList.toggle('show');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  }

  btn.addEventListener('click', toggle);
  if (closeBtn) closeBtn.addEventListener('click', toggle);
  if (overlay) overlay.addEventListener('click', toggle);

  // Collapse sections
  document.querySelectorAll('.mn-collapse-header').forEach(function(header) {
    header.addEventListener('click', function() {
      header.parentElement.classList.toggle('open');
    });
  });
})();

// -- Scroll reveal animation --
(function() {
  var reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  reveals.forEach(function(el) { observer.observe(el); });
})();

// -- Cart count --
(function() {
  function getCart() {
    try { return JSON.parse(localStorage.getItem('cc_cart') || '[]'); }
    catch(e) { return []; }
  }
  function updateCount() {
    var cart = getCart();
    var total = cart.reduce(function(sum, item) { return sum + (item.qty || 1); }, 0);
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = total;
      el.style.display = total > 0 ? '' : 'none';
    });
  }
  updateCount();
  window.CC_getCart = getCart;
  window.CC_updateCartCount = updateCount;
})();

// -- Toast notification --
window.CC_toast = function(message, type) {
  var container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }
  var toast = document.createElement('div');
  toast.className = 'toast ' + (type || '');
  toast.innerHTML = '<svg class="toast-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span>' + message + '</span>';
  container.appendChild(toast);
  setTimeout(function() {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(100%)';
    toast.style.transition = 'all .3s ease';
    setTimeout(function() { toast.remove(); }, 300);
  }, 3000);
};

// -- Add to cart --
window.CC_addToCart = function(product) {
  var cart = window.CC_getCart ? window.CC_getCart() : [];
  product.qty = product.qty || 1;
  product.id = product.id || ('item_' + Date.now());
  cart.push(product);
  localStorage.setItem('cc_cart', JSON.stringify(cart));
  if (window.CC_updateCartCount) window.CC_updateCartCount();
  window.CC_toast('Added to cart!', 'success');
};

// -- FAQ accordion (generic) --
(function() {
  // Homepage FAQ
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var q = item.querySelector('.faq-question');
    if (!q) return;
    q.addEventListener('click', function() {
      item.classList.toggle('open');
    });
  });
  // FAQ page accordion
  document.querySelectorAll('.faq-accordion-item').forEach(function(item) {
    var q = item.querySelector('.faq-accordion-q');
    if (!q) return;
    q.addEventListener('click', function() {
      var wasOpen = item.classList.contains('open');
      // Close siblings in same block
      var block = item.closest('.faq-category-block');
      if (block) {
        block.querySelectorAll('.faq-accordion-item.open').forEach(function(sibling) {
          if (sibling !== item) sibling.classList.remove('open');
        });
      }
      item.classList.toggle('open');
    });
  });
})();

// -- Smooth anchor scroll --
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var href = this.getAttribute('href');
    if (href === '#' || href === '#!') return;
    var target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      var offset = 80;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });
});

// -- Product card click --
document.querySelectorAll('[data-href]').forEach(function(el) {
  el.addEventListener('click', function() {
    var href = this.getAttribute('data-href');
    if (href) window.location.href = href;
  });
});
